export function bytesToHex(byteArray) {
    var hexParts = [];
    for (var i = 0; i < byteArray.length; ++i) {
        var hex = byteArray[i].toString(16);
        var paddedHex = ('00' + hex).slice(-2);
        hexParts.push(paddedHex);
    }
    return hexParts.join('');
}
//# sourceMappingURL=bytesToHex.js.map